import React from 'react';
import Header from './../Common/Header';
import Footer from './../Common/Footer';

var img1 = require('./../../images/left-men.png');
var img2 = require('./../../images/background/bg-4.png');
class GetFreeQuote extends React.Component {
    render() {
        return (
            <>

                <Header />
              
                <div className="section-full mobile-page-padding mission-outer-section  p-t80 p-b30 bg-gray bg-no-repeat bg-right-center" style={{ backgroundImage: 'url(' + img1 + '), url(' + img2 + ')' }}>
                <div className="section-full p-tb80 inner-page-padding">
                        {/* LOCATION BLOCK*/}
                        <div className="container">
                            {/* GOOGLE MAP & CONTACT FORM */}
                            <div className="section-content">
                                {/* CONTACT FORM*/}
                                <div className="row">
                                    <div className="col-md-8 col-sm-6">
                                        <form className="contact-form cons-contact-form" method="post" action="form-handler.php">
                                            <div className="contact-one m-b30">
                                                {/* TITLE START */}
                                                <div className="section-head">
                                                    <div className="mt-separator-outer separator-center">
                                                        <div className="mt-separator">
                                                            <h2 className="text-uppercase sep-line-one "><span className="font-weight-300 text-primary">Get</span>Free Quote</h2>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* TITLE END */}
                                                <h3 className="m-t0">Company Details</h3>
                                                <div className="form-group">
                                                    <input name="username" type="text" required className="form-control" placeholder="User Name" />
                                                </div>
                                                <div className="form-group">
                                                    <input name="email" type="text" className="form-control" required placeholder="Email" />
                                                </div>
                                                <div className="form-group">
                                                    <input name="phone" type="phone" className="form-control" required placeholder="Phone" />
                                                </div>
                                                <div className="form-group">
                                                    <input name="address" type="text" className="form-control" required placeholder="Address" />
                                                </div>
                                                <div className="form-group">
                                                    <input name="companyname" type="text" className="form-control" required placeholder="Company Name" />
                                                </div>
                                                  
                                                <h3 className="m-t0">Project Details</h3>
                                                <div className="form-group">
                                                    <input name="drawings" type="number" className="form-control" required placeholder="Number of Drawings" />
                                                </div>
                                                <div className="form-group">
                                                    <input name="days" type="number" className="form-control" required placeholder="Number of Days" />
                                                </div>
                                                <h3 className="m-t0">Upload Your Plans</h3>
                                                <div className="form-group">
                                                <input type="file" name="file" className="form-control" required placeholder="Choose Your File" accept="image/*,.pdf,.doc,.docx,.xls,.xlsx"/>
                                                </div>
                                                <div className="text-right">
                                                    <button name="login" type="login" value="Login" className="site-button btn-effect">Get Free Quote
                  </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                   
                                </div>
                            </div>
                        </div>
                    </div>
        </div>
                <Footer />

            </>
        );
    };
};

export default GetFreeQuote;